function scrollCarousel(e){const o=document.querySelectorAll("#carousel-items");o.length&&o.forEach(o=>{o.scrollBy({left:300*e,behavior:"smooth"})})}const carousels=document.querySelectorAll(".carousel-inner");carousels.length&&carousels.forEach(e=>{let o=!1,s=0,l=0;e.addEventListener("mousedown",r=>{o=!0,e.classList.add("dragging"),s=r.pageX,l=e.scrollLeft}),e.addEventListener("mousemove",r=>{if(!o)return;r.preventDefault();const t=2.5*(r.pageX-s);e.scrollLeft=l-t}),["mouseup","mouseleave"].forEach(s=>{e.addEventListener(s,()=>{o=!1,e.classList.remove("dragging")})})});

function logoSlider() {
   var sliders = document.getElementById('logo-list');
   if (sliders) {
      var flkty = new Flickity(sliders, {
         wrapAround: true,
         fullscreen: true,
        autoPlay: true,
         contain: true,
          pageDots: false,
        prevNextButtons: false,
      });
      sliders.classList.add('spring-slider-visible');
   }
}
logoSlider();


function LayoutSlider() {
   var slidersLayout = document.getElementById('layout-slider');
   if (slidersLayout) {
      var flkty = new Flickity(slidersLayout, {
         wrapAround: true,
         fullscreen: true,
        autoPlay: true,
         contain: true,
      pageDots: false,
      });
      slidersLayout.classList.add('spring-slider-visible');
   }
}
LayoutSlider();

function reviewSliders() {
   var slidersreview = document.getElementById('custom-reviews-slider');
   if (slidersreview) {
      var flkty = new Flickity(slidersreview, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
         pageDots: false
      });
      slidersreview.classList.add('spring-slider-visible');
   }
}
reviewSliders();


function reviewBSliders() {
   var slidersreviewB = document.getElementById('custom-reviews-sliderB');
   if (slidersreviewB) {
      var flkty = new Flickity(slidersreviewB, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
         pageDots: false,
        cellAlign: 'left'
      });
      slidersreviewB.classList.add('spring-slider-visible');
   }
}
reviewBSliders();

function imageSliders() {
   var sliderimage = document.getElementById('image-txt-slider');
   if (sliderimage) {
      var flkty = new Flickity(sliderimage, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
      });
      sliderimage.classList.add('spring-slider-visible');
   }
}
imageSliders();


function collectionSliders() {
   var slidercollection = document.getElementById('collection-sliders');
   if (slidercollection) {
      var flkty = new Flickity(slidercollection, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
      });
      slidercollection.classList.add('spring-slider-visible');
   }
}
collectionSliders();

(function initMobileFloatingWidgetScrollBehavior() {
  const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
  const widgetSelector = '.boom-launcher, #ShopifyChat';
  const scrollingClass = 'mobile-floating-widgets-scrolling';
  const returnDelay = 2000;
  let returnTimer;
  let animationFrame;

  function setWidgetOffsets() {
    document.querySelectorAll(widgetSelector).forEach((widget) => {
      if (widget.matches('.boom-launcher')) {
        if (widget.style.getPropertyValue('--mobile-floating-widget-hidden-right')) return;

        const launcherBox = widget.querySelector('#loloyal-launcher-box');
        const launcherWidth = (launcherBox || widget).getBoundingClientRect().width;

        if (launcherWidth > 0) {
          widget.style.setProperty(
            '--mobile-floating-widget-hidden-right',
            `${-(launcherWidth / 2)}px`
          );
        }
        return;
      }

      if (!widget.style.getPropertyValue('--mobile-floating-widget-right-gap')) {
        const computedRight = parseFloat(window.getComputedStyle(widget).right);
        const rightGap = Number.isFinite(computedRight)
          ? Math.max(0, computedRight)
          : Math.max(0, window.innerWidth - widget.getBoundingClientRect().right);

        widget.style.setProperty('--mobile-floating-widget-right-gap', `${rightGap}px`);
      }
    });
  }

  function restoreWidgets() {
    window.clearTimeout(returnTimer);
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }
    document.documentElement.classList.remove(scrollingClass);
  }

  function handleScroll() {
    if (!mobileMediaQuery.matches) return;

    if (!animationFrame) {
      animationFrame = window.requestAnimationFrame(() => {
        animationFrame = null;
        if (!mobileMediaQuery.matches) return;

        setWidgetOffsets();
        document.documentElement.classList.add(scrollingClass);
      });
    }

    window.clearTimeout(returnTimer);
    returnTimer = window.setTimeout(restoreWidgets, returnDelay);
  }

  function handleBreakpointChange() {
    restoreWidgets();

    document.querySelectorAll(widgetSelector).forEach((widget) => {
      widget.style.removeProperty('--mobile-floating-widget-right-gap');
      widget.style.removeProperty('--mobile-floating-widget-hidden-right');
    });
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  if (typeof mobileMediaQuery.addEventListener === 'function') {
    mobileMediaQuery.addEventListener('change', handleBreakpointChange);
  } else {
    mobileMediaQuery.addListener(handleBreakpointChange);
  }
})();

(function initShopifyChatProxyActivator() {
  const triggerClass = 'boxking-shopify-chat-trigger';
  const supportTriggerSelector = '[data-boxking-shopify-chat-open]';
  const activatorSelector = [
    'button[part~="activator"]',
    '#shopify-element-wrapper button.activator',
    'button.activator[aria-label="Help"]',
  ].join(', ');
  const maxOpenAttempts = 30;
  let openTimer;

  function findActivator(root) {
    if (!root || typeof root.querySelector !== 'function') return null;

    const activator = root.querySelector(activatorSelector);
    if (activator) return activator;

    const elements = root.querySelectorAll('*');
    for (const element of elements) {
      if (!element.shadowRoot) continue;
      const nestedActivator = findActivator(element.shadowRoot);
      if (nestedActivator) return nestedActivator;
    }

    return null;
  }

  function getShopifyChatActivator() {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return null;

    return findActivator(chat.shadowRoot || chat);
  }

  function openShopifyChat() {
    window.clearTimeout(openTimer);
    document.documentElement.classList.remove('mobile-floating-widgets-scrolling');

    let attempt = 0;
    const tryOpen = () => {
      const activator = getShopifyChatActivator();

      if (activator) {
        if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
        return;
      }

      attempt += 1;
      if (attempt < maxOpenAttempts) {
        openTimer = window.setTimeout(tryOpen, 100);
      }
    };

    tryOpen();
  }

  function ensureProxyTrigger() {
    if (!document.body || document.querySelector(`.${triggerClass}`)) return;
    if (!document.querySelector('shopify-chat')) return;

    const trigger = document.createElement('span');
    trigger.className = triggerClass;
    trigger.setAttribute('aria-hidden', 'true');
    trigger.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M20 15.25a3.75 3.75 0 0 1-3.75 3.75H8l-5 3V7.75A3.75 3.75 0 0 1 6.75 4h9.5A3.75 3.75 0 0 1 20 7.75v7.5Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    document.body.appendChild(trigger);
  }

  const documentObserver = new MutationObserver(ensureProxyTrigger);
  documentObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const supportTrigger = target && target.closest(supportTriggerSelector);
    if (!supportTrigger) return;

    event.preventDefault();
    openShopifyChat();
  });

  window.BoxKingShopifyChat = {
    open: openShopifyChat,
  };

  ensureProxyTrigger();
  customElements.whenDefined('shopify-chat').then(() => {
    window.requestAnimationFrame(ensureProxyTrigger);
  });
})();
